import { render, staticRenderFns } from "./ProjectCardLastUpdate.vue?vue&type=template&id=191ffca5"
import script from "./ProjectCardLastUpdate.vue?vue&type=script&lang=js"
export * from "./ProjectCardLastUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports